import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { QuickAddTrackingEventsContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddTrackingEventsContext/QuickAddTrackingEventsContext";
import { useGetProductTileClickImpressions } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useGetProductTileClickImpressions";
import { QuickAddModalContext } from "@faire/retailer/features/ProductQuickAddModal/QuickAddModalContext";
export var QuickAddTrackingEventsContextBaseProvider = function(_param) {
    var data = _param.data, children = _param.children, events = _object_without_properties(_param, [
        "data",
        "children"
    ]);
    var customOnQuickAddButtonClickEvent = events.onQuickAddButtonClick, customOnChooseOptionClickEvent = events.onChooseOptionClick, customOnChooseOptionQuantityUpdateSubmitEvent = events.onChooseOptionQuantityUpdateSubmit, getCartItemTokenByProductToken = events.getCartItemTokenByProductToken;
    var _useGetProductTileClickImpressions = useGetProductTileClickImpressions({
        token: data.productToken,
        impressionId: data.impressionId,
        promotedBy: data.promotedBy
    }), recordQuickAddSubmitEvent = _useGetProductTileClickImpressions.recordQuickAddSubmitEvent, recordQuickAddButtonClickEvent = _useGetProductTileClickImpressions.recordQuickAddButtonClickEvent, recordChooseOptionClickEvent = _useGetProductTileClickImpressions.recordChooseOptionClickEvent, recordChooseOptionQuantityUpdateSubmitEvent = _useGetProductTileClickImpressions.recordChooseOptionQuantityUpdateSubmitEvent, recordProductTileClickEvent = _useGetProductTileClickImpressions.recordProductTileClickEvent;
    var onQuickAddButtonClick = function(newQuantity) {
        customOnQuickAddButtonClickEvent === null || customOnQuickAddButtonClickEvent === void 0 ? void 0 : customOnQuickAddButtonClickEvent({
            productToken: data.productToken,
            newQuantity: newQuantity
        });
        recordQuickAddButtonClickEvent();
    };
    var onQuickAddSubmit = function(newQuantity) {
        recordQuickAddSubmitEvent(newQuantity);
    };
    var onChooseOptionClick = function() {
        customOnChooseOptionClickEvent === null || customOnChooseOptionClickEvent === void 0 ? void 0 : customOnChooseOptionClickEvent({
            productToken: data.productToken
        });
        recordChooseOptionClickEvent();
    };
    var onChooseOptionQuantityUpdateSubmit = function(newQuantity) {
        customOnChooseOptionQuantityUpdateSubmitEvent === null || customOnChooseOptionQuantityUpdateSubmitEvent === void 0 ? void 0 : customOnChooseOptionQuantityUpdateSubmitEvent({
            productToken: data.productToken,
            newQuantity: newQuantity
        });
        recordChooseOptionQuantityUpdateSubmitEvent(newQuantity);
    };
    // In the case where the user opens the quick add modal and navigates to the product details page,
    // we want to record a product tile click event
    var onViewProductDetailsClick = function() {
        recordProductTileClickEvent();
    };
    return /*#__PURE__*/ _jsx(QuickAddTrackingEventsContext.Provider, {
        value: {
            onQuickAddButtonClick: onQuickAddButtonClick,
            onQuickAddSubmit: onQuickAddSubmit,
            onChooseOptionClick: onChooseOptionClick,
            onChooseOptionQuantityUpdateSubmit: onChooseOptionQuantityUpdateSubmit,
            getCartItemTokenByProductToken: getCartItemTokenByProductToken
        },
        children: /*#__PURE__*/ _jsx(QuickAddModalContext.Provider, {
            value: {
                onViewProductDetailsClick: onViewProductDetailsClick
            },
            children: children
        })
    });
};
